<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title79">
<p class="p-c-br"><span>Dedicated to <br/>Robert James Burlison <br/>1920 – 1984</span></p></a></div><a id="title79">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783830763_ded01.vue?6a53f17b